// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2bp3Q","secondary":"Button_secondary__30Pku","outline":"Button_outline__3LKbn","disabled":"Button_disabled__1PRU7","ButtonSmal":"Button_ButtonSmal__3dfBN"};